import { render } from "./contractExamine.vue?vue&type=template&id=c65fbf54&scoped=true"
import script from "./contractExamine.vue?vue&type=script&lang=js"
export * from "./contractExamine.vue?vue&type=script&lang=js"

import "./contractExamine.vue?vue&type=style&index=0&id=c65fbf54&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c65fbf54"]])

export default __exports__